export default __webpack_public_path__ + "static/Budgeting-40e180cfa1dc37f68d05a3e47e670e95.webp";